import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Stack, StackProps, Typography, useTheme } from '@mui/material';

import { ModalContentProps } from './ModalManager';

interface ModalHeaderProps extends StackProps, ModalContentProps {
    title?: string;
    onClose: () => void;
}

function ModalHeader(props: ModalHeaderProps) {
    const { sx, onClose, title, ...stackProps } = props;
    const { palette } = useTheme();

    return (
        <Stack
            {...stackProps}
            sx={{
                // Default props
                gridArea: 'header',
                gap: 2.5,
                width: '100%',
                p: 2.5,
                flexShrink: 0,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                // Custom props
                ...sx,
            }}
        >
            {!!onClose && <Box sx={{ minWidth: '40px' }} />}
            {!!title && (
                <Typography variant="body1" sx={{ fontWeight: 600, textAlign: 'center' }}>
                    {title}
                </Typography>
            )}
            {!!onClose && (
                <IconButton
                    onClick={onClose}
                    disableRipple
                    sx={{ alignSelf: 'flex-end', right: 0, top: 0, pr: 0, pt: 0 }}
                >
                    <FontAwesomeIcon icon={faTimes} size="xs" color={palette.common.black} />
                </IconButton>
            )}
        </Stack>
    );
}

export default ModalHeader;
